import { createApp } from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from '@/router/index';
import { useDark } from '@/composables/useDark';

const app = createApp(App).use(Antd).use(router);
app.mount('#app');

// 初始化主题:在挂载后立即同步 useDark 状态,确保 <html data-theme> 正确
useDark().init();
